import { ArrowUp } from "lucide-react";

export const fmt$ = (v) => {
  if (v >= 1_000_000) return `$${(v / 1_000_000).toFixed(1)}M`;
  if (v >= 1_000) return `$${(v / 1_000).toFixed(0)}K`;
  return `$${v.toLocaleString()}`;
};

export const PIPE_COLORS = {
  active: "#2563eb",
  through_inspections: "#D97706",
  closed: "#059669",
  cancelled: "#dc2626",
};

export const PIPE_LABELS = {
  active: "Active",
  through_inspections: "Through Inspections",
  closed: "Closed",
  cancelled: "Cancelled",
};

export const PIE_COLORS = ["#2563eb", "#059669", "#D97706", "#dc2626", "#7c3aed", "#0891b2"];

export const StatCard = ({ icon: Icon, label, value, sub, color }) => (
  <div className="p-4 rounded-lg" style={{ background: "var(--t-card)", border: "1px solid var(--t-border)" }}>
    <div className="flex items-center gap-3">
      <div className="w-9 h-9 rounded-lg flex items-center justify-center flex-shrink-0" style={{ background: color + "18", color }}>
        <Icon className="w-4.5 h-4.5" />
      </div>
      <div>
        <p className="text-xs font-medium" style={{ color: "var(--t-text-muted)" }}>{label}</p>
        <p className="text-xl font-bold mt-0.5" style={{ color: "var(--t-text)", fontFamily: "var(--t-heading-font)" }}>{value}</p>
        {sub && <p className="text-[11px] mt-0.5" style={{ color: "var(--t-text-subtle)" }}>{sub}</p>}
      </div>
    </div>
  </div>
);

export const SectionHeader = ({ icon: Icon, title, subtitle }) => {
  const scrollToTop = () => {
    const el = document.getElementById("reports-top");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };
  return (
    <button onClick={scrollToTop} className="flex items-center gap-3 mb-4 pt-2 group w-full text-left cursor-pointer" data-testid={`section-header-${title}`}>
      <div className="w-8 h-8 rounded-lg flex items-center justify-center" style={{ background: "var(--t-primary)", color: "#fff" }}>
        <Icon className="w-4 h-4" />
      </div>
      <div className="flex-1">
        <h2 className="text-base font-bold group-hover:underline" style={{ color: "var(--t-text)", fontFamily: "var(--t-heading-font)" }}>{title}</h2>
        {subtitle && <p className="text-xs" style={{ color: "var(--t-text-muted)" }}>{subtitle}</p>}
      </div>
      <ArrowUp className="w-4 h-4 opacity-0 group-hover:opacity-100 transition-opacity" style={{ color: "var(--t-text-muted)" }} />
    </button>
  );
};

export const ChartTooltipContent = ({ active, payload, label, prefix = "" }) => {
  if (!active || !payload?.length) return null;
  return (
    <div className="px-3 py-2 rounded-lg text-xs shadow-lg" style={{ background: "var(--t-card)", border: "1px solid var(--t-border)" }}>
      <p className="font-medium mb-1" style={{ color: "var(--t-text)" }}>{label}</p>
      {payload.map((p) => (
        <p key={p.name} style={{ color: p.color }}>{p.name}: {prefix}{typeof p.value === "number" ? p.value.toLocaleString() : p.value}</p>
      ))}
    </div>
  );
};
